import { Select } from "@mantine/core";
import { useForm } from "@mantine/form";

export default function ProductReturnStatus({ onCardClick, status }) {
  const form = useForm({
    initialValues: {
      status: status || null,
    },
  });

  // Static status options
  const statusOptions = [
    { label: "Pending", value: "PENDING" },
    { label: "Rejected", value: "REJECTED" },
    { label: "Paid", value: "PAID" },
    { label: "Resolved", value: "RESOLVED" },
    { label: "Payment Request", value: "PAYMENT_REQUEST" },
  ];

  const handleStatusSelect = (value) => {
    form.setFieldValue("status", value);
    if (onCardClick) {
      onCardClick(value);
    }
  };

  return (
    <Select
      placeholder="Filter by Status"
      data={statusOptions}
      value={form.values.status}
      onChange={handleStatusSelect}
      clearable
      searchable
      withinPortal
    />
  );
}
